import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { DocumentTitle } from '@atlassian/jira-global-document-title';
import { injectIntl } from '@atlassian/jira-intl';

import type { TabData } from '@atlassian/jira-portfolio-3-common/src/tabs/types';
import { FirePlanCreationEventFromThePrevWizard } from '@atlassian/jira-portfolio-3-create-new-plan-wizard-analytics';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';
import { redirectToPlanPage } from '@atlassian/jira-portfolio-3-portfolio/src/common/window';

import messages from './messages';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import AsyncDependencies from './tabs/dependencies/async';
import AsyncReleases from './tabs/releases/async';
import Roadmap from './tabs/roadmap';
import AsyncTeams from './tabs/teams/async';
import type { Props } from './types';

// eslint-disable-next-line jira/react/no-class-components
class Main extends Component<Props> {
	static defaultProps = {
		Roadmap,
		Teams: AsyncTeams,
		Releases: AsyncReleases,
		Dependencies: AsyncDependencies,
	};

	TabContent = () => {
		const {
			// eslint-disable-next-line @typescript-eslint/no-shadow
			Roadmap,
			// eslint-disable-next-line @typescript-eslint/no-shadow
			Teams: AsyncTeams,
			// eslint-disable-next-line @typescript-eslint/no-shadow
			Releases: AsyncReleases,
			match: { url },
		} = this.props;

		return (
			<Switch>
				<Redirect to="/plan/backlog" from="/plan" exact />
				<Route path={`${url}/backlog`} component={Roadmap} />
				<Route path={`${url}/teams`} component={AsyncTeams} />
				<Route path={`${url}/releases`} component={AsyncReleases} />
				<Route path={`${url}/dependencies`} component={AsyncDependencies} />
			</Switch>
		);
	};

	render() {
		const {
			intl,
			planTitle,
			isReportMode,
			// eslint-disable-next-line @typescript-eslint/no-shadow
			Roadmap,
			location: { pathname },
		} = this.props;

		const productName = intl.formatMessage(messages.plans);

		const documentTitle = isDefined(planTitle) ? `${planTitle} - ${productName}` : `${productName}`;

		if (isReportMode) {
			return (
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				<div className={styles.roadmapReportingWrapper}>
					<DocumentTitle title={documentTitle} />
					<Roadmap />
				</div>
			);
		}

		const tabs: TabData[] = [
			{
				label: intl.formatMessage(messages.roadmapTabLabel),
				value: 'ROADMAP',
				link: '/backlog',
				testId: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap',
			},
			{
				label: intl.formatMessage(messages.teamsTabLabel),
				value: 'TEAMS',
				link: '/teams',
				testId: 'portfolio-3-portfolio.app-simple-plans.main.tabs.teams',
			},
			{
				label: intl.formatMessage(messages.releasesTabLabel),
				value: 'RELEASES',
				link: '/releases',
			},
			{
				label: intl.formatMessage(messages.dependenciesTabLabel),
				value: 'DEPENDENCIES',
				link: '/dependencies',
				testId: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies',
			},
		];

		let selectedTab = tabs.find(({ link }) => `/plan${link}` === pathname);
		selectedTab = isDefined(selectedTab) ? selectedTab : tabs[0];
		redirectToPlanPage(selectedTab.link);

		return (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			<section className={styles.main} aria-label={intl.formatMessage(messages.planAndTimeline)}>
				{this.TabContent()}
				<DocumentTitle title={documentTitle} />
				<FirePlanCreationEventFromThePrevWizard />
			</section>
		);
	}
}

export default injectIntl(Main);
